var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCotiza2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.375,
    height: 48.375,
    viewBox: "0 0 48.375 48.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21012",
    "data-name": "Group 21012",
    transform: "translate(18943.756 14247.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7671",
    "data-name": "Path 7671",
    d: "M224.545,46.874l-.261-.062V52.6c2.185-.207,3.43-1.331,3.43-2.97,0-1.435-1-2.25-3.169-2.752",
    transform: "translate(-19143 -14269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7672",
    "data-name": "Path 7672",
    d: "M219.7,40.739c0,1.268.967,2.115,2.752,2.526h.016V37.944a2.934,2.934,0,0,0-2.768,2.795",
    transform: "translate(-19143 -14269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7673",
    "data-name": "Path 7673",
    d: "M223.433,21.058A24.187,24.187,0,1,0,247.62,45.245a24.188,24.188,0,0,0-24.187-24.187m.849,34.131V57.34h-1.814V55.213c-4.088-.271-6.364-2.515-6.592-5.4H219.1a3.655,3.655,0,0,0,3.367,2.722V46.382l-1.2-.295c-3.045-.707-4.872-2.438-4.872-5.157a5.914,5.914,0,0,1,6.071-5.6V33.153h1.814v2.123a6.122,6.122,0,0,1,6.429,5.183h-3.182a3.387,3.387,0,0,0-3.247-2.575v5.805l1.432.339c3.392.793,5.273,2.333,5.273,5.321,0,3.283-2.472,5.544-6.705,5.84",
    transform: "translate(-19143 -14269)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCotiza2);
export default __webpack_public_path__ + "static/media/icon_cotiza2.ac6c5f7a38c329c8b55e49eb52a08840.svg";
export { ForwardRef as ReactComponent };